import type { CustomFieldFilterValues } from '@erp/shared';

export function activeCustomFieldFilterCount(values: CustomFieldFilterValues): number {
  return Object.keys(values).length;
}
